import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import FollowupLogDataService from "../../services/FollowupLogs";

export const DeleteFollowupModal = ({ isOpen, onClose, func, id }: any) => {
  const deleteFollowup = async () => {
    try {
      const res = await FollowupLogDataService.deleteFollowupLog(id);
      console.log(res);
      func();
      onClose();
    } catch (error) {
      console.log(error);
      onClose();
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Followup</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{`Are you sure you want to delete?`}</ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={deleteFollowup}
          >
            Delete
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
